import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Paper, Typography } from "@material-ui/core";
import AutorenewRoundedIcon from "@material-ui/icons/AutorenewRounded";
import useStyles from "@/styles/dashboardStyle";
import { useTranslation } from "@/langs/useTranslation";
import { useQueryParams } from "@/containers/Dashboard";
import { DashboardAlarmDeviceListDatatable } from "@/helpers/dashboardAlarmDeviceListDatatable";
import { resetAlarmDeviceApi } from "@/apis/apiCollection";
import { toast } from "@/apis/request";
import modalConfirm from "../Modal/modalConfirm";

function queryParamsAdapter(params) {
  return {
    groupIds: params.group_ids,
    tagIds: params.tag_ids,
    includeChildCompany: params.hasSubCompanies === 1
  };
}

const AlarmDeviceDatatable = props => {
  const classes = useStyles();
  const tableRef = useRef(null);
  const { t } = useTranslation();
  const [queryParams] = useQueryParams();

  const reloadTable = () => {
    tableRef.current?.reload();
  };

  const getSearchParams = () => {
    return queryParamsAdapter(queryParams);
  };

  const doReset = async rows => {
    if (!Array.isArray(rows)) {
      rows = [rows];
    }
    await resetAlarmDeviceApi({
      resetDevices: rows.map(row => ({
        deviceId: row.deviceId,
        alarmPolicyId: row.alarmPolicyId
      }))
    });
    reloadTable();
    toast.success(t({ defaultMessage: "操作成功" }));
  };

  const handleAlarmReset = row => {
    modalConfirm({
      title: t({ defaultMessage: "重置提醒" }),
      content: t(
        {
          defaultMessage:
            "是否确认重置（{name}）该报警设备？重置后报警规则将继续执行监控。"
        },
        { name: row.deviceSerialNumber }
      ),
      onConfirm: () => {
        return doReset(row);
      }
    });
  };

  useEffect(() => {
    reloadTable();
  }, [queryParams]);

  return (
    <Paper elevation={0}>
      <div className={classes.blockTitle}>
        <Typography
          variant="h6"
          className={classes.cardTitleWrapWithReloadIcon}
        >
          {props.title}
          <AutorenewRoundedIcon
            onClick={reloadTable}
            size="small"
            className={classes.reload_btn}
          />
        </Typography>
        <Link to="/alarm/device-list?triggerStatus=1">
          {t({ defaultMessage: "查看更多 >" })}
        </Link>
      </div>
      <DashboardAlarmDeviceListDatatable
        ref={tableRef}
        getSearchParams={getSearchParams}
        onReset={handleAlarmReset}
      />
    </Paper>
  );
};

export default AlarmDeviceDatatable;
